import React from "react";

export default function Insurance() {
  return (
    <div className="insurance-page">

      {/* HERO */}
      <div className="insurance-hero">
        <h1>વીમા યોજના</h1>
        <p>
          શ્રી ધનલક્ષ્મી મહિલા કો-ઓપ. ક્રેડિટ સોસાયટી લિ. દ્વારા સભ્યો માટે
          ખાસ વીમા સુરક્ષા યોજના શરૂ કરવામાં આવી છે, જે તમારા અને તમારા પરિવાર
          માટે આર્થિક સુરક્ષા પૂરી પાડે છે.
        </p>
      </div>

      {/* MAIN SCHEME */}
      <div className="insurance-highlight">
        <h2>₹3,00,000 સુધીની વીમા સુરક્ષા</h2>
        <p>
          તા. 01/04/2025 થી ₹3,00,000 સુધીની વીમા યોજના સંપૂર્ણપણે શરૂ કરવામાં આવી છે.
          આ યોજના સભ્યોને અચાનક ઘટના સમયે આર્થિક મદદ પૂરી પાડે છે.
        </p>
      </div>

      <div className="insurance-main container">

  {/* LEFT - BENEFITS */}
  <div className="insurance-left">
    <h2>વીમા યોજનાના લાભો</h2>

    <div className="insurance-card">
      <h3>પરિવાર સુરક્ષા</h3>
      <p>અકસ્મત સમયે આર્થિક સહાય</p>
    </div>

    <div className="insurance-card">
      <h3>ઓછી ફી</h3>
      <p>નાના પ્રીમિયમમાં વધુ સુરક્ષા</p>
    </div>

    <div className="insurance-card">
      <h3>ઝડપી ક્લેમ</h3>
      <p>સરળ પ્રક્રિયા</p>
    </div>

    <div className="insurance-card">
      <h3>સભ્યો માટે ખાસ</h3>
      <p>ફક્ત સભ્યો માટે યોજના</p>
    </div>
  </div>

  {/* CENTER - RULES + DETAILS */}
  <div className="insurance-center">
    <h2>મુખ્ય નિયમો</h2>
    <ul>
      <li>વીમા ફક્ત સભ્યો માટે જ રહેશે</li>
      <li>સભ્ય બન્યા બાદ યોજના લાગુ થશે</li>
      <li>વીમા રકમ નિયમ મુજબ મળશે</li>
      <li>જરૂરી દસ્તાવેજ ફરજિયાત છે</li>
      <li>ક્લેમ નિયમ મુજબ જ મળશે</li>
    </ul>

    <h2>યોજનાની માહિતી</h2>
    <p>
      આ યોજના મહિલાઓને આર્થિક સુરક્ષા આપવા માટે બનાવવામાં આવી છે.
      અચાનક ઘટના સમયે પરિવારને આર્થિક મદદ મળે છે.
    </p>
  </div>

  {/* RIGHT - DOCS + PROCESS */}
  <div className="insurance-right">
    <h2>જરૂરી દસ્તાવેજો</h2>
    <div className="doc-list">
      <div>આધાર કાર્ડ</div>
      <div>પાન કાર્ડ</div>
      <div>ફોટોગ્રાફ</div>
      <div>સરનામું પુરાવો</div>
      <div>બેંક પાસબુક</div>
    </div>

    <h2>ક્લેમ પ્રક્રિયા</h2>
    <ol>
      <li>ઓફિસમાં અરજી કરો</li>
      <li>દસ્તાવેજ સબમિટ કરો</li>
      <li>ચકાસણી થશે</li>
      <li>મંજૂરી પછી રકમ મળશે</li>
    </ol>
  </div>

</div>

      {/* CTA */}
      <div className="insurance-cta">
        <h2>હવે જોડાઓ અને સુરક્ષિત બનો</h2>
        <p>
          આજે જ સભ્ય બનો અને તમારા પરિવારને આર્થિક સુરક્ષા આપો.
        </p>
        <button>હવે અરજી કરો</button>
      </div>

    </div>
  );
}